import BaseService from './BaseService'

class AddressService extends BaseService {

  constructor () {
    super({path: 'addresses'})
  }

  async addAddress ({ entity, entityId, data }) {
    try {
      let res = await this.instance.post(`${entity}/${entityId}/addresses`, data)
      return res.data
    } catch (e) {
      this._handleError({translationKey: 'address.add.error', error: e})
      throw e
    }
  }

  async updateAddress ({ entity, entityId, data }) {
    try {
      let res = await this.instance.put(`${entity}/${entityId}/address/${data.id}`, data)
      return res.data
    } catch (e) {
      this._handleError({translationKey: 'address.update.error', error: e})
      throw e
    }
  }

  async deleteAddress ({ entity, entityId, id }) {
    try {
      let res = await this.instance.delete(`${entity}/${entityId}/address/${id}`)
      return res.data
    } catch (e) {
      this._handleError({translationKey: 'address.delete.error', error: e})
      throw e
    }
  }

  async setPrimary ({ entity, entityId, id }) {
    try {
      let res = await this.instance.post(`${entity}/${entityId}/address/${id}/primary`, {})
      return res.data
    } catch (e) {
      this._handleError({translationKey: 'address.set.primary.error', error: e})
      throw e
    }
  }

  async setFinancial ({ entity, entityId, id }) {
    try {
      let res = await this.instance.post(`${entity}/${entityId}/address/${id}/financial`, {})
      return res.data
    } catch (e) {
      this._handleError({translationKey: 'address.set.financial.error', error: e})
      throw e
    }
  }

  async setDelivery ({ entity, entityId, id }) {
    try {
      let res = await this.instance.post(`${entity}/${entityId}/address/${id}/delivery`, {})
      return res.data
    } catch (e) {
      this._handleError({translationKey: 'address.set.delivery.error', error: e})
      throw e
    }
  }

}

export default new AddressService()
